import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { PageService } from "app/services/page-service";

@Component({
  selector: "app-updatedeliveryuser-password",
  templateUrl: "./updatedeliveryuser-password.component.html",
  styles: [],
})
export class UpdatedeliveryuserPasswordComponent implements OnInit {
  @Input() content: any;
  test: Date = new Date();
  formId: FormGroup;
  loader = false;
  submitted = false;
  errorMessage = "";
  successMessage = "";
  constructor(
    public dialogRef: NgbActiveModal,
    public fb: FormBuilder,
    public service: PageService,
    public route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.formId = this.fb.group(
      {
        password: ["", [Validators.required]],
        confirmPassword: ["", [Validators.required]],
      },
      { validator: this.checkPassword("password", "confirmPassword") }
    );
  }
  get f() {
    return this.formId.controls;
  }

  checkPassword(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        // return if another validator has already found an error on the matchingControl
        return;
      }
      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
        return matchingControl.status == "VALID" ? true : false;
      } else {
        matchingControl.setErrors(null);
        return matchingControl.status == "VALID" ? true : false;
      }
    };
  }

  onSubmit() {
    this.submitted = true;
    if (this.formId.invalid) {
      return;
    }
    this.loader = true;
    this.errorMessage = "";
    this.successMessage = "";
    this.service
      .updateuserPassword(this.content["data"]["record"]._id, this.formId.value)
      .then((data) => {
        this.loader = false;
        this.dialogRef.close({ success: true });
      })
      .catch((err) => {
        this.dialogRef.close({ success: true });
      });
    console.log(this.content);
  }

  close() {
    this.dialogRef.close({ success: false });
  }
}
